import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M12 3.75c-4.549 0-8.25 3.701-8.25 8.25s3.701 8.25 8.25 8.25 8.25-3.701 8.25-8.25S16.549 3.75 12 3.75zm0 15.469c-3.98 0-7.219-3.239-7.219-7.219S8.02 4.781 12 4.781 19.219 8.02 19.219 12 15.98 19.219 12 19.219z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M15.609 11.484h-3.094V7.359a.516.516 0 1 0-1.032 0V12c0 .285.231.516.516.516h3.609a.516.516 0 1 0 0-1.032z"
  })]
}), 'Clock');